<template>
  <!-- 「買越多送越多」階梯公告：折扣券＋滿額贈依門檻由低到高排成一條（直接讀後台設定，自動同步） -->
  <div v-if="steps.length" class="promo-ladder">
    <div class="pl-title">🎁 買越多送越多</div>
    <div class="pl-steps">
      <template v-for="(s, i) in steps" :key="s.key">
        <span class="pl-step">
          <span class="pl-min">滿 ${{ s.min.toLocaleString() }}</span>
          <span class="pl-text">{{ s.text }}</span>
          <span v-if="s.expire != null" class="pl-expire">⏳倒數{{ s.expire }}天</span>
        </span>
        <span v-if="i < steps.length - 1" class="pl-arrow">➜</span>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { buildPromoSteps } from '@/utils/promoData'

const props = defineProps({
  gifts: { type: Array, default: () => [] },
  coupons: { type: Array, default: () => [] },
})
const steps = computed(() => buildPromoSteps(props.gifts, props.coupons))
</script>

<style scoped>
.promo-ladder {
  margin: 8px auto;
  padding: 12px 16px;
  border: 1px solid #f5c08a;
  border-radius: 10px;
  background: linear-gradient(90deg, #fff7ee, #fffaf4);
  text-align: center;
}
.pl-title {
  font-weight: 700;
  color: #cc4400;
  font-size: 1rem;
  margin-bottom: 8px;
}
.pl-steps {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 6px 8px;
}
.pl-step {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #f3d2b0;
  font-size: 0.92rem;
}
.pl-min {
  font-weight: 800;
  color: #c0392b;
  white-space: nowrap;
}
.pl-text {
  color: #8a3a00;
  font-weight: 600;
}
.pl-expire {
  color: #c0392b;
  font-size: 0.8rem;
  font-weight: 700;
  white-space: nowrap;
}
.pl-arrow {
  color: #e08a3c;
  font-weight: 700;
}
@media (max-width: 600px) {
  .promo-ladder { padding: 10px 12px; }
  .pl-steps { flex-direction: column; gap: 4px; }
  .pl-arrow { transform: rotate(90deg); line-height: 1; }
  .pl-step { font-size: 0.88rem; }
}
</style>
